import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLinkedinIn, FaInstagram, FaGlobe } from "react-icons/fa"; 
import "./Home.css";
import bgVideo from "../uploads/3922709-hd_1920_1080_25fps.mp4";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper">

     
      <video autoPlay loop muted playsInline className="background-video">
        <source src={bgVideo} type="video/mp4" />
      </video>

      
      <div className="overlay"></div>

    
      <section className="hero">
        <div className="hero-content">

          <span className="tag animate-fade">
            Reliability • Dedication • Success
          </span>

          <h1 className="animate-slide">
            Grow Your <br />
            <span className="gradient-text">Business With Us</span>
          </h1>

          <p className="animate-fade delay">
            We deliver smart, scalable and future-ready digital solutions
            that help businesses streamline operations and accelerate growth.
          </p>

          <div className="hero-buttons animate-fade delay-more">
            <button 
              className="btn-primary"
              onClick={() => navigate("/services")}
            >
              Get Started
            </button>

            <button 
              className="btn-glass"
              onClick={() => navigate("/contact")}
            >
              Learn More
            </button>
          </div>

        </div>
      </section>

     
      <footer className="trending-footer">

        <div className="footer-wave"></div>

        <div className="footer-content">
          <h2>Let’s Build Something Amazing Together</h2>
          <p>Empowering businesses with innovative digital solutions.</p>

       
          <div className="social-icons">
            
            
            <a 
              href="https://rdstechnology.in/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaGlobe />
            </a>

            <a 
              href="https://www.linkedin.com/company/rdstechnology/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>

     
            <a 
              href="https://www.instagram.com/rds_technology" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

          </div>

          <div className="footer-bottom">
            © {new Date().getFullYear()} RDS Technology. All Rights Reserved.
          </div>
        </div>

      </footer>

    </div>
  );
}

export default Home;